module.exports = __webpack_public_path__ + "instance.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instance.png
// module id = 29
// module chunks = 0